import { createContext } from "react";
import service, { IService } from "./service";

const ServiceContext = createContext<IService>(service);
export default ServiceContext;
